export default __webpack_public_path__ + "static/metabolic_card_desktop-1ed548954f24a280101734458f509a2f.png";